<template>
	<div>
		<a-upload
			name="avatar"
			list-type="picture-card"
			class="avatar-uploader"
			:show-upload-list="false"
			:before-upload="beforeUpload"
			@change="handleChange"
		>
			<img v-if="imageUrl" :src="imageUrl" alt="avatar" />
			<div v-else>
				<a-icon :type="loading ? 'loading' : 'plus'" />
				<div class="ant-upload-text">
					Upload
				</div>
			</div>
		</a-upload>
	</div>
</template>
<script>
import { USER as USER_ACTIONS } from '@/store/actions'
import { mapActions, mapGetters } from 'vuex'

function getBase64(img, callback) {
	const reader = new FileReader()
	reader.addEventListener('load', () => callback(reader.result))
	reader.readAsDataURL(img)
}
export default {
	data() {
		return {
			loading: false,
			imageUrl: '',
		}
	},
	methods: {
		...mapActions({ updateAvatar: USER_ACTIONS.AVATAR }),

		handleChange(info) {
			if (info.file.status === 'uploading') {
				this.loading = true
				return
			}
			if (info.file.status === 'done') {
				// Get this url from response in real world.
				getBase64(info.file.originFileObj, imageUrl => {
					this.imageUrl = imageUrl
					this.loading = false
				})
			}
		},
		beforeUpload(file) {
			this.$notification.warning('Unsuported yet')
			/*
			const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
			if (!isJpgOrPng) {
				this.$notification.error('You can only upload JPG/PNG file!')
			}
			const isLt2M = file.size / 1024 / 1024 < 2
			if (!isLt2M) {
				this.$notification.error('Image must smaller than 2MB!')
			}

			if (isJpgOrPng && isLt2M) {
				return this.handleUpload(file)
			} else {
				return false
			}
			*/
		},

		handleUpload(file) {
			this.updateAvatar({ id: this.getCurrentUser.id, file: file }).then(e => {
			})
			// You can use any AJAX library you like
		},
	},
	computed: {
		...mapGetters(['getCurrentUser']),
	},
}
</script>
<style>
.avatar-uploader > .ant-upload {
	width: 128px;
	height: 128px;
}
.ant-upload-select-picture-card i {
	font-size: 32px;
	color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
	margin-top: 8px;
	color: #666;
}
</style>
